import { ZodError, z } from 'zod'
import { consolo } from '../composables/consolo'

 
const OpcionesZod = z.object({
  error: z.any().optional(),
  datos: z.any().optional(),

  origen: z.string().optional(),
  alertar: z.boolean().optional(),

  respuesta: z.object({
    codigo: z.string(),
    datos: z.any()
  })
    .optional()
})
type Opciones = z.infer<typeof OpcionesZod>

export class ErrorAumentado extends Error {
  version: string
  trazado: string[] = []

  alertar = true

  override cause?: Error
  origen?: string

  datos?: unknown

  respuesta?: {
        codigo: string
        datos?: unknown
    }

  constructor(message: string, opciones?: Opciones) {
    super(message)
    const contexto = unref(contextoApp)
    this.version = contexto ? contexto.buildConfig.version : 'preinit'
    this.name = 'ErrorAumentado'
    this.alertar
            = (!opciones || opciones.alertar === undefined) ? true : opciones.alertar

    if (opciones) {
      if (opciones.origen) {
        this.origen = opciones.origen
        this.trazado.push(opciones.origen)
      }
      this.cause = opciones.error
      if (opciones.error instanceof ZodError) {
    consolo.log('[error]', '🛃 Error de parseo')
        const issues = opciones.error.issues
        for (const [issueID, issue] of Object.entries(issues)) {
          const {
            path,
            code,
            message,
            expected,
            received
          } = Object.assign({
            expected: '',
            received: ''
          }, issue)
        consolo.error('[error]', `Issue ${issueID} @ ${path.join(' . ')}\n`, `expected: ${expected}; received: ${received}\n`, `code: ${code}; message: ${message}`)
        }
      }

      if (opciones.datos)
        this.datos = opciones.datos
      if (this.alertar)
        consolo.error('[error]', '%c ErrorAumentado: ', message, this.datos, this)
    }
  }

  trazar(fx: string) {
    consolo.log('[error]', '  Agregado al trazado: ', fx)
    this.trazado.push(fx)
    return this
  }
}
